// project import
// types
import { NavItemType } from '../types/menu';
import { useConfigurationMenuItems } from './configuration';
import { useMemo } from 'react';
import { useDashboardMenuItems } from './dashboard';
import { useManagementMenuItems } from './management';
import { DeepReadonly } from '../types/DeepReadonly';

// ==============================|| MENU ITEMS ||============================== //

const useMenuItems = (): { items: DeepReadonly<NavItemType>[] } => {
	const dashboard = useDashboardMenuItems();
	const management = useManagementMenuItems();
	const configuration = useConfigurationMenuItems();

	return useMemo(
		() => ({
			items: [dashboard, management, configuration],
		}),
		[dashboard, management, configuration],
	);
};

export { useMenuItems };
